/**
 * 竞价实时信息大屏显示
 */
import React from 'react';
import "./AuctionedTable.css";
import "./HeadBanner.css";
import http from '../../../axios/http';
import moment from 'moment';
import logoImg from "./img/logo.png";
import backgroundImg from "./img/background1.jpg";
import "../../../style/ui/icon.css";

import AuctionRegion from "./AuctionRegion.jsx";

const weekMap = {
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六",
    "0": "日",
}

//组织机构代码和区域的映射表
const orgCodeRegionMap = {
    "00010001000500020001": "fz",
    "00010001000500030001": "qz",
    "00010001000500040001": "pt",
    "00010001000500050001": "km",
    "00010001000500060001": "sy",
    "00010001000500070001": "st",
    "00010001000500080001" : "nn",
    "00010001000500100001" : "cc",
    "00010001000500110001" : "ly",
    "00010001000500120001" : "xa"
}

class AuctionedTable extends React.Component {
    state = {
        data: [],
        sessionList: [], //场次列表
        currentLots: [],
    }

    componentDidMount() {
        //初始化时间
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY-MM-DD ");
        let day = now.day() + "";
        this.initData();
        this.dateInitTimer = setInterval(() => this.initData(), 175000);
        this.setState({
            time: time,
            date: date + "星期" + weekMap[day],
        });
        //设置右上角的时间
        this.initTime();
        this.timerID = setInterval(() => this.initTime(), 1000);
    }

    initTime = () => {
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY-MM-DD ");
        let day = now.day() + "";
        this.setState({
            time: time,
            date: date + "星期" + weekMap[day]
        });
    }

    initData = () => {
        http.get({
            url: '/auction/largescreen/findSessionList',
            success: (sessionList) => {
                if (sessionList) {
                    for (let i = 0; i < sessionList.length; i++) {
                        sessionList[i].imageThumbnailStr = 'data:image/jpeg;base64,' + sessionList[i].imageThumbnail
                    }
                }
                //竞拍数据
                http.get({
                    url: '/auction/largescreen/loadtask',
                    success: (currentLots) => {
                        let regionSessionMap = {
                            "xm": null,
                            "fz": null,
                            "qz": null,
                            "pt": null,
                            "km": null,
                            "sy": null,
                            "st": null,
                            "nn": null,
                            "cc": null,
                            "ly": null,
                            "xa": null
                        };
                        if (sessionList !== undefined && sessionList !== null && sessionList.length > 0) {
                            sessionList.forEach((item, index) => {
                                //判断orgCode是哪个区，用区拼音首字母表示
                                if (item.status !== 2 && item.orgCode) {
                                    let region = orgCodeRegionMap[item.orgCode];
                                    if (!region) {
                                        //默认是厦门
                                        region = "xm";
                                    }
                                    let old = regionSessionMap[region];
                                    if (!old) {
                                        regionSessionMap[region] = item;
                                    }
                                    else {
                                        let startTimeOld = moment(old.startTime);
                                        let startTimeNew = moment(item.startTime);
                                        if (startTimeNew.isBefore(startTimeOld)) {
                                            regionSessionMap[region] = item;
                                        }
                                    }
                                    //判断场次是否是进行中
                                    if (item.status !== 2) {
                                        currentLots.forEach((lot, i) => {
                                            if (lot.sessionId === item.id) {
                                                item.lotsInfo = lot;
                                            }
                                        })
                                    }
                                }
                            });
                        }
                        let doms = [];
                        let i = 0;
                        for (let field in regionSessionMap) {
                            let center = false;
                            if (i % 3 === 1) {
                                center = true;
                            }
                            i++;
                            doms.push((<AuctionRegion key={field} center={center} region={field} session={regionSessionMap[field]} />));
                        }
                        this.setState({
                            sessionList: sessionList,
                            currentLots: currentLots,
                            regionItem: doms
                        });
                    }
                });
            }
        })
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
        clearInterval(this.dateInitTimer);
    }

    openSessionDetail = (id) => {
        let url = window.location.origin + "/large/auctionLots?sessionId=" + id;
        window.open(url, "auctionLots");
    }

    render() {
        return (
            <div className="root" style={{ background: 'url(' + backgroundImg + ') no-repeat', backgroundSize: 'cover' }}>
                <div className="head" style={{ textAlign: 'center' }}>
                    <div className="head-container">
                        <div className='head-left head-div'>
                            <img className="head-logo-img" src={logoImg} alt="logo" />
                            <div className="head-logo-text">厦门二手车交易市场网上竞价大厅</div>
                        </div>
                        <div className='head-center head-div'>
                            {/* <img className="head-status-img" src={completeImg} alt="status" /> */}
                        </div>
                        <div className='head-right head-div'>
                            <span className="head-right-time">{this.state.time}</span><br />
                            <span className="head-right-date">{this.state.date}</span>
                        </div>
                    </div>
                </div>
                <div className='main-container'>
                    <div className="main">
                        <div className="main-left main-background">
                            <div className="left-top">
                            </div>
                            <div className="session-container">
                                {this.state.sessionList && this.state.sessionList.length > 0 ? this.state.sessionList.map((item, index) => {
                                    let tabStyle = item.id === this.state.currentId ? "session-item active" : "session-item"
                                    return <div className={tabStyle} key={index} onClick={this.openSessionDetail.bind(this, item.id)}>
                                        <div className="session-imgbox">
                                            <div className="session-img" style={{ float: 'left', width: '100%', height: '100%', background: "url(" + item.imageThumbnailStr + ") no-repeat center center #FFF", backgroundSize: "contain" }}>
                                                {/* <div className="session-logo-img" style={{ width: '100%', height: '100%', background: "url(" + logo1Img + ") no-repeat center center", backgroundSize: "contain" }}>
                                            </div> */}
                                            </div>
                                            {/* <div className="session-mask">
                                            <img className="session-imglogo" src={logo1Img} alt=""></img>
                                        </div> */}
                                        </div>
                                        <div className='session-title'>
                                            <div className="session-title-text">{item.name}</div>
                                            <span className="session-title-time"><span className='iconfont icon-clock red-color'></span>&nbsp; {item.endTime ? item.endTime : item.startTime}</span>
                                        </div>
                                        {/* <Icon type="right-circle" theme="filled" style={{ color: 'red', position: 'absolute', right: '24px', top: '38px', fontSize: '24px' }} /> */}
                                    </div>
                                }) : ''}

                            </div>
                        </div>
                        <div className='auction-item-container'>
                            {/* <AuctionRegion region="xm" lotsDetail={this.lotsDetail}/> */}
                            {this.state.regionItem}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default AuctionedTable;